import { mat4, vec3 } from "gl-matrix";
import { wHitRecord } from "./wHitRecord.js";
import { wPlane } from "./wPlane.js";

class wCircle {
    constructor(centerPosition, normal, radius, slices) {
        this.center_ = (centerPosition !== undefined) ? centerPosition : vec3.fromValues(0.0, 0.0, 0.0);
        this.normal_ = vec3.fromValues(1.0, 0.0, 0.0);
        if ( normal !== undefined ) {
            vec3.normalize(this.normal_, normal)
        }
        this.radius_ = radius !== undefined ? radius : 1.0;
        this.slices_ = slices !== undefined ? slices : 8; // of slices in the rendered circle, not used yet
    }

    setCircle(pos, normal, radius){
        vec3.copy(this.center_, pos); 
        vec3.copy(this.normal_, normal);
        this.radius_ = radius;
    }

    setCenterPosition(pos) {
        vec3.copy(this.center_, pos);
    }

    setNormal(normal) {
        vec3.copy(this.normal_, normal);
    }

    getNumberOfSlices() {
        return this.slices_;
    }

    getRadius() {
        return this.radius_;
    }

    getCenterPoint() {
        var P = vec3.create();
        vec3.copy(P, this.center_);
        return P;
    }

    getNormal() {
        var N = vec3.create();
        vec3.copy(N, this.normal_);
        return N;
    }

    rayCircleClosestDistance(ray) {
        let hitRecord = new wHitRecord();
        let circlePlane = new wPlane(this.normal_, this.center_);
       
        hitRecord = circlePlane.rayIntersect(ray);
        if (hitRecord.validHit_) {
            let planePoint = ray.evaluateRay(hitRecord.hitTimes_[0]);
            // project that point on to the circle's circumference
            let circleProjectedPoint = vec3.create();
            let tmp = vec3.create();
            vec3.subtract(tmp, planePoint, this.center_);
            let tmp1 = vec3.create();
            vec3.normalize(tmp1, tmp);
            let tmp2 = vec3.create();
            vec3.scale(tmp2, tmp1, this.radius_);
            vec3.add(circleProjectedPoint, this.center_, tmp2);
            let tmp3 = vec3.create();
            vec3.subtract(tmp3, planePoint, circleProjectedPoint);
            return [vec3.length(tmp3), hitRecord.hitTimes_[0]];
        }

        // the required point on the circle is the one closest to the camera origin
        // point = radius_ * glm::normalize(Fundament::FmMath::vectorRejection(ray.getOrigin() - center_, normal_));
        return [1000.0, 1000.0]; // distance_between_point_ray(point, context.camera_ray);
    }

    rayIntersect(ray) {
        var hitRecord = new wHitRecord();
        let circlePlane = new wPlane(this.normal_, this.center_);
        hitRecord = circlePlane.rayIntersect(ray);

        if (hitRecord.validHit_) {
            let t = hitRecord.hitTimes_[0];
            let hitPos = ray.evaluateRay(t);
            let hitDir = vec3.create();
            vec3.sub(hitDir, hitPos, this.center_);

            // check length of hitDir
            let cProj = vec3.length(hitDir);

            if (Math.abs(cProj) < this.radius_) {
                hitRecord.validHit_ = true;
                hitRecord.hitTimes_.push(t);
            } else {
                return new wHitRecord();
            }
        }

        return hitRecord;
    }

    translate(t) {
        this.center_[0] += t[0];
        this.center_[1] += t[1];
        this.center_[2] += t[2];
     /*   let tmp = vec3.create();
        vec3.add(tmp, t, this.center_);
        this.setCenterPosition(tmp);*/
    }

    transform( m ) {       
        let tmp = vec3.create();
        vec3.transformMat4(tmp, this.center_, m);
        vec3.copy(this.center_, tmp);
        vec3.transformMat4(tmp, this.normal_, m);
        vec3.copy(this.normal_, tmp);
        mat4.getScaling(tmp,m);
        let s = vec3.dot(tmp,vec3.fromValues(1.0,1.0,1.0));
        s /= 3.0;
        this.radius_ = this.radius_*s;
    }
}

export { wCircle };
